import styled from "styled-components";




export const SModalContas = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0, 0.3);
    .layer {
        z-index: 99;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
    .modal-wrapper {
        width: 400px;
        padding: 12px;
        background-color: #fff;
        border-radius: 12px;
        z-index: 99;
    }
`;